import React from "react";

export const TextBox = (props) => {
  const {
    register,
    id,
    errors,
    maxLength,
    disabled,
    type,
    placeholder,
    icon,
    getError,
    value,
    staticVal,
    setValue,
    className,
    ...rest
  } = props;

  if (staticVal) {
    setValue(id, staticVal);
  }

  const error = getError?.(errors) || errors?.[id];

  // Common onChange handler for number fields
  const handleChange = (e) => {
    let value = e.target.value;

    if (type === "number") {
      // Remove non-numeric and scientific notation characters
      value = value.replace(/[eE+\-]/g, "");

      // Restrict to a maximum digits
      if (maxLength && value.length > maxLength) {
        value = value.slice(0, maxLength);
      }

      e.target.value = value;
    }

    if (rest.onChange) {
      rest.onChange(e); // Call user-defined onChange if provided
    }
  };

  // Common onPaste handler for number fields
  const handlePaste = (e) => {
    if (type === "number") {
      const pastedText = (e.clipboardData || window.clipboardData).getData(
        "text"
      );

      // Prevent pasting invalid characters
      if (/[eE+\-]/.test(pastedText)) {
        e.preventDefault();
      }
    }

    if (rest.onPaste) {
      rest.onPaste(e); // Call user-defined onPaste if provided
    }
  };

  return (
    <React.Fragment>
      <input
        id={id}
        placeholder={placeholder}
        name={id}
        {...register(id, {
          valueAsNumber: type === "number",
        })}
        className={`form-control ${error ? "is-invalid" : ""} ${
          icon ? "icon-enabled" : ""
        } ${className}`}
        type={type ? type : "text"}
        onKeyDown={(evt) =>
          type === "number" &&
          ["e", "E", "+", "-"].includes(evt.key) &&
          evt.preventDefault()
        }
        maxLength={maxLength}
        disabled={disabled}
        defaultValue={value}
        step="any"
        autoComplete="off"
        onChange={handleChange}
        onPaste={handlePaste}
        {...rest}
      />
      {error && <p className="invalid-feedback"> {error.message}</p>}
    </React.Fragment>
  );
};

export default TextBox;
